var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        (function () {
            var ExcursionsPage = function () {
                function ExcursionsPage(root) {
                    _classCallCheck(this, ExcursionsPage);

                    this.root = root;
                    this.listUrl = root.dataset.listUrl || '';
                    this.countrySlug = root.dataset.countrySlug || '';
                    this.tourists = root.dataset.tourists || '';

                    this.contentElement = root.querySelector('.js-excursions-content');
                    this.listElement = root.querySelector('.js-excursions-list');
                    this.loadingElement = root.querySelector('.js-excursions-loading');
                    this.loadingProgressFillElement = root.querySelector('.js-excursions-loading-progress-fill');
                    this.emptyElement = root.querySelector('.js-excursions-empty');

                    this.isLoading = false;
                    this.loadingProgressFrameId = null;
                    this.loadingProgressStartedAt = 0;

                    this.initFilters();
                    this.initUiSelectSlider();
                    this.updateEmptyState();
                }

                _createClass(ExcursionsPage, [{
                    key: "initFilters",
                    value: function initFilters() {
                        var root = this.root;
                        root.addEventListener('ui-select:change', function (event) {
                            var select = event.target.closest('.ui-select');
                            if (!select || !select.closest('.js-excursions-filters-select-slider')) {
                                return;
                            }

                            var detail = event.detail || {};
                            this.applyUiSelectFilter(detail.widgetId || '', detail.value || '');
                        }.bind(this));
                    }
                }, {
                    key: "applyUiSelectFilter",
                    value: function applyUiSelectFilter(widgetId, value) {
                        var state = {
                            countrySlug: this.countrySlug,
                            tourists: this.tourists
                        };

                        if (widgetId === 'excursions-country-filter') {
                            state.countrySlug = value;
                        } else if (widgetId === 'excursions-tourists-filter') {
                            state.tourists = value;
                        } else {
                            return;
                        }

                        this.applyFiltersState(state);
                    }
                }, {
                    key: "applyFiltersState",
                    value: function applyFiltersState(state) {
                        if (this.isLoading) {
                            return;
                        }

                        var nextCountrySlug = state.countrySlug || '';
                        var nextTourists = state.tourists || '';

                        if (nextCountrySlug === this.countrySlug && nextTourists === this.tourists) {
                            return;
                        }

                        this.countrySlug = nextCountrySlug;
                        this.tourists = nextTourists;

                        this.fetchExcursions(this.buildFiltersUrl());
                    }
                }, {
                    key: "buildFiltersUrl",
                    value: function buildFiltersUrl() {
                        var path = '/new/excursions';

                        if (this.countrySlug) {
                            path += '/' + encodeURIComponent(this.countrySlug);
                        }

                        if (this.tourists === 'with-children') {
                            path += '?tourists=' + encodeURIComponent(this.tourists);
                        }

                        return path;
                    }
                }, {
                    key: "initUiSelectSlider",
                    value: function initUiSelectSlider() {
                        if (!window.UiSelectSlider || typeof window.UiSelectSlider.initAll !== 'function' || !this.contentElement) {
                            return;
                        }

                        window.UiSelectSlider.initAll(this.contentElement);
                    }
                }, {
                    key: "fetchExcursions",
                    value: function fetchExcursions(urlForHistory) {
                        if (this.isLoading || !this.listUrl) {
                            return;
                        }

                        this.isLoading = true;
                        this.showReplacingState();
                        this.startLoadingProgress();

                        var params = new URLSearchParams();
                        if (this.countrySlug) {
                            params.set('countrySlug', this.countrySlug);
                        }
                        if (this.tourists) {
                            params.set('tourists', this.tourists);
                        }

                        fetch(this.listUrl + '?' + params.toString(), {
                            method: 'GET',
                            headers: {
                                'X-Requested-With': 'XMLHttpRequest'
                            }
                        }).then(function (response) {
                            return response.json();
                        }).then(function (data) {
                            if (!data || !data.success || !this.contentElement) {
                                return;
                            }

                            this.contentElement.innerHTML = data.html || '';
                            this.listElement = this.root.querySelector('.js-excursions-list');
                            this.root.dataset.countrySlug = data.countrySlug || '';
                            this.root.dataset.tourists = data.tourists || '';
                            this.countrySlug = data.countrySlug || '';
                            this.tourists = data.tourists || '';
                            this.initUiSelectSlider();

                            if (urlForHistory) {
                                window.history.pushState({}, '', urlForHistory);
                            }

                            this.updateEmptyState();
                        }.bind(this)).finally(function () {
                            this.isLoading = false;
                            this.stopLoadingProgress();
                            this.hideReplacingState();
                        }.bind(this));
                    }
                }, {
                    key: "showReplacingState",
                    value: function showReplacingState() {
                        if (this.listElement) {
                            this.listElement.classList.add('is-hidden');
                        }

                        if (this.emptyElement) {
                            this.emptyElement.classList.add('is-hidden');
                        }

                        if (this.loadingElement) {
                            this.loadingElement.classList.remove('is-hidden');
                        }

                        this.root.classList.add('is-replacing');
                    }
                }, {
                    key: "hideReplacingState",
                    value: function hideReplacingState() {
                        if (this.listElement) {
                            this.listElement.classList.remove('is-hidden');
                        }

                        if (this.loadingElement) {
                            this.loadingElement.classList.add('is-hidden');
                        }

                        this.root.classList.remove('is-replacing');
                    }
                }, {
                    key: "startLoadingProgress",
                    value: function startLoadingProgress() {
                        if (!this.loadingProgressFillElement) {
                            return;
                        }

                        this.stopLoadingProgress();
                        this.loadingProgressFillElement.style.width = '0%';
                        this.loadingProgressStartedAt = performance.now();

                        var duration = 10000;
                        var animate = function (timestamp) {
                            var elapsed = timestamp - this.loadingProgressStartedAt;
                            var progress = Math.min(elapsed / duration, 1);
                            this.loadingProgressFillElement.style.width = String(progress * 100) + '%';

                            if (progress < 1) {
                                this.loadingProgressFrameId = window.requestAnimationFrame(animate);
                            }
                        }.bind(this);

                        this.loadingProgressFrameId = window.requestAnimationFrame(animate);
                    }
                }, {
                    key: "stopLoadingProgress",
                    value: function stopLoadingProgress() {
                        if (this.loadingProgressFrameId) {
                            window.cancelAnimationFrame(this.loadingProgressFrameId);
                            this.loadingProgressFrameId = null;
                        }

                        if (this.loadingProgressFillElement) {
                            this.loadingProgressFillElement.style.width = '0%';
                        }
                    }
                }, {
                    key: "updateEmptyState",
                    value: function updateEmptyState() {
                        if (!this.emptyElement || !this.listElement) {
                            return;
                        }

                        var hasBlocks = this.listElement.querySelector('.excursions-block') !== null;
                        this.emptyElement.classList.toggle('is-hidden', hasBlocks);
                    }
                }]);

                return ExcursionsPage;
            }();

            function initExcursionsPage() {
                var root = document.getElementById('excursions-page');
                if (!root || root.dataset.inited === '1') {
                    return;
                }

                new ExcursionsPage(root);
                root.dataset.inited = '1';
            }

            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', initExcursionsPage);
            } else {
                initExcursionsPage();
            }
        })();
    }, {}] }, {}, [1]);